/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import BaseCom from "./BaseCom";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class Home extends BaseCom {
    async componentDidMount() {
        await this.getSettings();
        setTimeout(() => {
            if(this.state.MODEL === 'MNF')
                this.props.navigate('/inventory');
            else
                this.props.navigate('/dashboard');
        }, 100);
    }
    render() {
        return null;
    }
}

export default withParamsAndNavigate(Home);